import { useQuery } from '@tanstack/react-query';
import { api } from '@weebee/api';
import { queryKeys } from '../query-keys';

export function useMyPrograms() {
  return useQuery({
    queryKey: queryKeys.programs.my(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/programs/me');
      if (error) throw error;
      return data;
    },
  });
}

export function useAvailablePrograms() {
  return useQuery({
    queryKey: queryKeys.programs.available(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/programs/available');
      if (error) throw error;
      return data;
    },
  });
}

export function useProgramBenefits(programId: string) {
  return useQuery({
    queryKey: queryKeys.programs.benefits(programId),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/programs/{programId}/benefits', {
        params: { path: { programId } },
      });
      if (error) throw error;
      return data;
    },
    enabled: !!programId,
  });
}

export function useMyEnrollments() {
  return useQuery({
    queryKey: queryKeys.programs.enrollments(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/programs/enrollments');
      if (error) throw error;
      return data;
    },
  });
}
